import { TenantSignalsScreen } from "@src/features/patriot-tools";

export default TenantSignalsScreen;
